<div class="popup-wrapper">
    <div class="headings">
        <div class="headings-header">
            <span>nCash</span>
        </div>
        <div class="headings-info">
            <span>Below are your selected nCash preferences, you can always choose to modify your preferences from the Dashboard after your account is successfully verified.
            </span>
        </div>
    </div>
    <div class="ncash-body">
        <div class="ncash-property-wrapper">
            <div class="ncash-property">
                <span class="property-label">Type</span>
                <span class="property-value">{{productInfo.type}}</span>
            </div>
            <div class="ncash-property">
                <span class="property-label">Frequency</span>
                <span class="property-value">{{productInfo.frequency?.toUpperCase()}}</span>
            </div>
            <div class="ncash-property">
                <span class="property-label">Date</span>
                <span class="property-value">{{productInfo.date}}<sup>th</sup> of Month</span>
            </div>
        </div>
        <div class="ncash-body-btn">
            <button (click)="onClickBack()" class="back-btn">
                Back
            </button>
        </div>
    </div>
</div>